<template>

  <ul class="pagination">
    <li is="paginator-page-button"
        v-for="(page, index) in pages"
        :key="index"
        :page="page"
        :current-number="activePage"
        @activated="navigateToPage(page)"
    />
  </ul>
</template>

<script>
import PaginatorPageButton from './PaginatorPageButton'
import Paginator from '../../pagination/paginator'

export default {
  name: 'Paginator',
  components: {
    PaginatorPageButton
  },
  props: {
    totalCount: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: false,
      default: 10
    },
    activePage: {
      type: Number,
      required: true
    }
  },
  computed: {
    pages: function () {
      const paginator = new Paginator(this.totalCount, this.pageSize)
      const pages = paginator.getPages(this.activePage)
      return pages
    }
  },
  methods: {
    navigateToPage: function (page) {
      if (page.number === undefined) {
        return
      }
      this.$emit('pageActivated', page.number)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/paginator/Paginator.vue